require('./Chips.scss');

const React = require('react'),
    Router = require('react-router'),
    {Navigation} = Router,
    { PropTypes } = require('react');

const Chip = React.createClass({displayName: "Chip",

    mixins: [Navigation],

    propTypes: {
        icon: PropTypes.string,
        text: PropTypes.string,
        link: PropTypes.string,
        onClickLink: PropTypes.func,
        bgColorIcon: PropTypes.string,
        colorIcon: PropTypes.string,
        className: PropTypes.string
    },

    _onClickLink() {
        const {onClickLink, link} = this.props;

        if (link) {
            const param = link.substring(link.indexOf(':') + 1, link.length);
            this.transitionTo(link, {selectLocationItemId: param});
            if (onClickLink) {
                onClickLink();
            }
        }
    },

    render() {
        const { icon, text, bgColorIcon, colorIcon, className} = this.props;
        let classNameEl = 'bp-chip';

        if (className) {
            classNameEl += ' ' + className;
        }

        const iconEl = icon
            ? React.createElement("span", {className: "bp-chip__icon"}, 
                  React.createElement("i", {
                      dangerouslySetInnerHTML: { __html: icon}, 
                      className: "material-icons", 
                      style: {color: colorIcon || 'black', backgroundColor: bgColorIcon}}
                  )
              )
            : null;

        return (
            React.createElement("div", {onClick: this._onClickLink, className: classNameEl}, 
                React.createElement("span", {className: "bp-chip__text"}, text), 
                React.createElement("span", {className: "txt-default pull-left"}, iconEl)
            )
        );
    }
});

module.exports = Chip;



/** WEBPACK FOOTER **
 ** ./src/components/Chips/Chips.jsx
 **/